import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";

const SetupGameplay = () => {
  const [configGame, setConfigGame] = useState(null);
  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

  // Core theo wireframe → map sang entity thực tế
  const [minChiHang, setMinChiHang] = useState(5);    // jackpotRate.minGame
  const [maxChiHang, setMaxChiHang] = useState(10);   // jackpotRate.maxGame
  const [totalSymbols, setTotalSymbols] = useState(25); // totalSymbols
  const [turnDuration, setTurnDuration] = useState(60); // turnDuration
  const [chiHangInterval, setChiHangInterval] = useState(50); // jackpotRate.moonGoddessAppearanceTime
  const [moonGoddessEndTime, setMoonGoddessEndTime] = useState(50); // jackpotRate.moonGoddessEndTime

  // Hai tốc độ cần → map sang speedDrop / speedMiss của BE
  const [speedThaCan, setSpeedThaCan] = useState(1_000); // sẽ gửi vào speedDrop
  const [speedThuCan, setSpeedThuCan] = useState(1_000); // sẽ gửi vào speedMiss

  // Tốc độ/kích thước vật phẩm (mỗi size 1 ô; Chị Hằng 1 ô mặc định)
  const [itemSpeeds, setItemSpeeds] = useState({
    da_big: 1000,
    da_small: 1000,
    canhCay_big: 1000,
    canhCay_small: 1000,
    banhTrungThu_big: 1000,
    banhTrungThu_small: 1000,
    longDen_big: 1000,
    longDen_small: 1000,
    thoNgoc_big: 1000,
    thoNgoc_small: 1000,
    trangRam_big: 1000,
    trangRam_small: 1000,
    chiHang_default: 1000,
    hopQua_big: 1000,
    hopQua_small: 1000,
  });

  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getDataConfig();
  }, []);

  const getDataConfig = async () => {
    try {
      const res = await API.get(CONFIG);
      const data = res?.data?.data || {};
      setConfigGame(data);

      setTurnDuration(data?.turnDuration ?? 60);
      setTotalSymbols(data?.totalSymbols ?? 25);

      // jackpotRate mapping
      setMinChiHang(data?.jackpotRate?.minGame ?? 5);
      setMaxChiHang(data?.jackpotRate?.maxGame ?? 10);
      setChiHangInterval(data?.jackpotRate?.moonGoddessAppearanceTime ?? 50);
      setMoonGoddessEndTime(data?.jackpotRate?.moonGoddessEndTime ?? 50);

      // map speedDrop/speedMiss (BE là số nhỏ kiểu 1.0, 1.8; UI bạn nhập số nào cũng được)
      setSpeedThaCan(data?.speedDrop ?? 1.0);
      setSpeedThuCan(data?.speedMiss ?? 1.8);

      // map speed object → các ô lớn/nhỏ
      const sp = data?.speed || {};
      setItemSpeeds({
        da_big: sp?.ROCK?.MAX ?? 1000,
        da_small: sp?.ROCK?.MIN ?? 1000,
        canhCay_big: sp?.BRANCH?.MAX ?? 1000,
        canhCay_small: sp?.BRANCH?.MIN ?? 1000,
        banhTrungThu_big: sp?.MOON_CAKE?.MAX ?? 1000,
        banhTrungThu_small: sp?.MOON_CAKE?.MIN ?? 1000,
        longDen_big: sp?.LANTERN?.MAX ?? 1000,
        longDen_small: sp?.LANTERN?.MIN ?? 1000,
        thoNgoc_big: sp?.JADE_RABBIT?.MAX ?? 1000,
        thoNgoc_small: sp?.JADE_RABBIT?.MIN ?? 1000,
        trangRam_big: sp?.FULL_MOON?.MAX ?? 1000,
        trangRam_small: sp?.FULL_MOON?.MIN ?? 1000,
        // Chị hằng chỉ có 1 ô → map vào MAX (BE default chỉ có MAX)
        chiHang_default: sp?.MOON_GODDESS?.MAX ?? 1000,
        hopQua_big: sp?.JADE_BOX?.MAX ?? sp?.GIFT_BOX?.MAX ?? sp?.GIFT?.MAX ?? 1000,
        hopQua_small: sp?.JADE_BOX?.MIN ?? sp?.GIFT_BOX?.MIN ?? sp?.GIFT?.MIN ?? 1000,
      });
    } catch (err) {
      console.log(err);
      messageApi.error("Không tải được cấu hình.");
    }
  };

  const validPos = (v) => Number.isFinite(Number(v)) && Number(v) > 0;
  const validNonNeg = (v) => Number.isFinite(Number(v)) && Number(v) >= 0;

  const handleUpdateConfig = async () => {
    try {
      setIsShowModalConfirm(false);

      if (
        !validPos(minChiHang) ||
        !validPos(maxChiHang) ||
        !validPos(totalSymbols) ||
        !validPos(turnDuration) ||
        !validPos(chiHangInterval) ||
        !validPos(moonGoddessEndTime) ||
        !validNonNeg(speedThaCan) ||
        !validNonNeg(speedThuCan)
      ) {
        messageApi.error("Vui lòng nhập số hợp lệ.");
        return;
      }
      if (Number(minChiHang) > Number(maxChiHang)) {
        messageApi.error("Giá trị Min không được lớn hơn Max.");
        return;
      }

      // build payload theo đúng schema BE
      const payload = {
        config: {
          turnDuration: Number(turnDuration),
          totalSymbols: Number(totalSymbols),

          // thả/thu cần → map speedDrop/speedMiss
          speedDrop: Number(speedThaCan),
          speedMiss: Number(speedThuCan),

          jackpotRate: {
            minGame: Number(minChiHang),
            maxGame: Number(maxChiHang),
            moonGoddessAppearanceTime: Number(chiHangInterval),
            moonGoddessEndTime: Number(moonGoddessEndTime),
          },

          // map big -> MAX, small -> MIN; Chị Hằng chỉ MAX
          speed: {
            ROCK: { MIN: Number(itemSpeeds.da_small), MAX: Number(itemSpeeds.da_big) },
            BRANCH: { MIN: Number(itemSpeeds.canhCay_small), MAX: Number(itemSpeeds.canhCay_big) },
            MOON_CAKE: { MIN: Number(itemSpeeds.banhTrungThu_small), MAX: Number(itemSpeeds.banhTrungThu_big) },
            LANTERN: { MIN: Number(itemSpeeds.longDen_small), MAX: Number(itemSpeeds.longDen_big) },
            JADE_RABBIT: { MIN: Number(itemSpeeds.thoNgoc_small), MAX: Number(itemSpeeds.thoNgoc_big) },
            FULL_MOON: { MIN: Number(itemSpeeds.trangRam_small), MAX: Number(itemSpeeds.trangRam_big) },
            MOON_GODDESS: { MAX: Number(itemSpeeds.chiHang_default) },
            JADE_BOX: { MIN: Number(itemSpeeds.hopQua_small), MAX: Number(itemSpeeds.hopQua_big) },
          },
        },
      };

      await API.patch(UPDATE_CONFIG, payload);
      setIsShowModalSuccess(true);
    } catch (err) {
      console.log(err);
      messageApi.error(err?.response?.data?.message || "Cập nhật thất bại.");
    }
  };

  // === UI helpers (giữ đúng style 2 cột của bạn) ===
  const RowNumber = (
    key,
    value,
    onChange,
    max,
    label,
    suffix,
    min = 0,
    precision,
    step
  ) => (
    <div className={`flex w-full items-center ${key ? "mt-4" : ""}`}>
      <div className="flex w-[30%] justify-end mr-10">{label}:</div>
      <div className="w-[50%]">
        <InputNumber
          key={key}
          style={{ width: "100%" }}
          value={value}
          onChange={(v) => onChange(Number(v ?? 0))}
          max={max}
          min={min}
          precision={precision}
          step={step ?? 1} 
          addonAfter={suffix}
        />
      </div>
    </div>
  );

  const ItemSpeedRow = (stateKey, label) =>
  RowNumber(
    String(stateKey),
    itemSpeeds[stateKey],
    (v) => setItemSpeeds((s) => ({ ...s, [stateKey]: v })),
    50000,
    label,
    undefined,
    0,
    2,      // precision 2 số lẻ
    0.1     // bước 0.1
  );

  return (
    <div className="col-12" style={{ background: "#f7f9fa", minHeight: "100vh", padding: 24 }}>
      {contextHolder}
      {configGame && (
        <div className="col-12">
          <div className="flex w-full">
            <div className="flex flex-col w-full items-center justify-center">
              <div className="col-10 mt-2 flex flex-col items-center justify-center">
                <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 8 }}>
                  Cài đặt tốc độ & vật phẩm
                </div>

                {RowNumber("minChiHang", minChiHang, setMinChiHang, 100, "Số lần xuất hiện chị hằng (Min)", undefined, 1)}
                {RowNumber("maxChiHang", maxChiHang, setMaxChiHang, 100, "Số lần xuất hiện chị hằng (Max)", undefined, 1)}
                {RowNumber("totalSymbols", totalSymbols, setTotalSymbols, 500, "Số lượng của tất cả vật thể", undefined, 1)}
                {RowNumber("turnDuration", turnDuration, setTurnDuration, 600, "Số giây mỗi lượt", "giây", 1)}
                {RowNumber("chiHangInterval", chiHangInterval, setChiHangInterval, 3600, "Thời điểm chị Hằng xuất hiện", "giây", 1)}
                {RowNumber("moonGoddessEndTime", moonGoddessEndTime, setMoonGoddessEndTime, 3600, "Thời điểm biến mất chị Hằng", "giây", 1)}
                {RowNumber("speedThaCan", speedThaCan, setSpeedThaCan, 50000, "Tốc độ thả cần", undefined, 0, 2, 0.1)}
                {RowNumber("speedThuCan", speedThuCan, setSpeedThuCan, 50000, "Tốc độ thu cần",  undefined, 0, 2, 0.1)}

                <div style={{ fontWeight: 600, fontSize: 16, marginTop: 24 }}>
                  Cài đặt tốc độ/kích thước vật phẩm
                </div>
                {ItemSpeedRow("da_big", "Đá - Lớn")}
                {ItemSpeedRow("da_small", "Đá - Nhỏ")}
                {ItemSpeedRow("canhCay_big", "Cành cây - Lớn")}
                {ItemSpeedRow("canhCay_small", "Cành cây - Nhỏ")}
                {ItemSpeedRow("banhTrungThu_big", "Bánh trung thu - Lớn")}
                {ItemSpeedRow("banhTrungThu_small", "Bánh trung thu - Nhỏ")}
                {ItemSpeedRow("longDen_big", "Lồng đèn - Lớn")}
                {ItemSpeedRow("longDen_small", "Lồng đèn - Nhỏ")}
                {ItemSpeedRow("thoNgoc_big", "Thỏ ngọc - Lớn")}
                {ItemSpeedRow("thoNgoc_small", "Thỏ ngọc - Nhỏ")}
                {ItemSpeedRow("trangRam_big", "Trăng rằm - Lớn")}
                {ItemSpeedRow("trangRam_small", "Trăng rằm - Nhỏ")}
                {ItemSpeedRow("chiHang_default", "Chị hằng")}
                {ItemSpeedRow("hopQua_big", "Hộp quà - Lớn")}
                {ItemSpeedRow("hopQua_small", "Hộp quà - Nhỏ")}
              </div>

              <div className="col-10 mt-5 flex items-center justify-center">
                <Button type="primary" onClick={() => setIsShowModalConfirm(true)}>
                  Lưu
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isShowModalConfirm && (
        <ModalCommon
          isShow={isShowModalConfirm}
          message={TEXT_DEF.text0062}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0023}
          actionNext={handleUpdateConfig}
          close={() => setIsShowModalConfirm(false)}
        />
      )}
      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={TEXT_DEF.text0063}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => setIsShowModalSuccess(false)}
          close={() => setIsShowModalSuccess(false)}
        />
      )}
    </div>
  );
};

export default SetupGameplay;
